import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProgramsData as fetchAcademicProgramsData, // Alias for academic programs
  fetchDepartmentsData,
  fetchLoanData,
} from "../../redux/slicer/academicSlice";

import { fetchDepartmentsData as fetchDepartmentDataFromSlice } from "../../redux/slicer/departmentsSlice"; // Correct import
import {
  fetchCQAData,
  fetchCQADescriptionData,
} from "../../redux/slicer/gallerySlice";
import { fetchInternshipData } from "../../redux/slicer/researchAndStudentSlice";
import { FaLink } from "react-icons/fa";
import { TiArrowSortedDown } from "react-icons/ti";
import { GoArrowRight } from "react-icons/go";
import { GiGraduateCap } from "react-icons/gi";
import { BiSolidRightArrow } from "react-icons/bi";
import Background from "../../assets/background_2.png";
import { useNavigate, Link } from "react-router-dom"; // Import Link
import parse, { domToReact } from "html-react-parser";
import Preloader from "../../assets/sab.jpeg"; // Preloader image
import AcedamicsImg from "../../assets/Banners/Academics.jpg";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const MAROON = "#800000"; // Maroon
const PURPLE = "#800080"; // Purple

function Acadamics() {
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const dispatch = useDispatch();

  const {
    data: departmentsData,
    loading: departmentsLoading,
    error: departmentsError,
  } = useSelector((state) => state.academic.departments);

  const {
    data: departmentData,
    loading: departmentLoading,
    error: departmentError,
  } = useSelector((state) => state.departments.departments);

  const {
    data: programsData,
    loading: programsLoading,
    error: programsError,
  } = useSelector((state) => state.academic.programs);

  const {
    data: loanData,
    loading: loanLoading,
    error: loanError,
  } = useSelector((state) => state.academic.loan);
  const {
    data: internshipData,
    loading: internshipLoading,
    error: internshipError,
  } = useSelector((state) => state.research.internship);
  const {
    data: CQAData,
    loading: CQALoading,
    error: CQAError,
  } = useSelector((state) => state.gallery.CQA);

  const {
    data: CQADescriptionData,
    loading: CQADescriptionLoading,
    error: CQADescriptionError,
  } = useSelector((state) => state.gallery.CQADescription);

  // Fetch data on component mount
  useEffect(() => {
    dispatch(fetchDepartmentsData());
    dispatch(fetchAcademicProgramsData());
    dispatch(fetchDepartmentDataFromSlice());
    dispatch(fetchLoanData());
    dispatch(fetchInternshipData());
    dispatch(fetchCQAData());
    dispatch(fetchCQADescriptionData());
  }, [dispatch]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const safeParse = (value, fallback = "N/A") => {
    if (typeof value === "string" && value.trim()) {
      try {
        return parse(value, {
          replace: (domNode) => {
            if (domNode.name === "ol") {
              return (
                <ol className="list-decimal pl-6">
                  {domToReact(domNode.children)}
                </ol>
              );
            }
            if (domNode.name === "ul") {
              return (
                <ul className="list-disc pl-6">
                  {domToReact(domNode.children)}
                </ul>
              );
            }
            if (domNode.name === "li") {
              return (
                <li className="text-justify">{domToReact(domNode.children)}</li>
              );
            }
          },
        });
      } catch (error) {
        console.error(`Failed to parse HTML: ${value}`, error);
        return fallback;
      }
    }
    console.warn(`Invalid value for parsing: ${value}`);
    return fallback;
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth", // Smooth scrolling
    });
  };
  const [activeTab, setActiveTab] = useState("LoanScheme01");
  const [showFullText, setShowFullText] = useState(false);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Default for xl & 2xl
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280, // lg screens
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024, // md screens
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // sm screens
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (
    departmentsLoading ||
    programsLoading ||
    loanLoading ||
    departmentLoading
  ) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (departmentsError || programsError || loanError || departmentError) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">
          Error:{" "}
          {departmentsError || programsError || loanError || departmentError}
        </p>
      </div>
    );
  }
  return (
    <div className="bg-gray-100 ">
      <div className="relative max-w-full mx-auto">
        <div className="contain overflow-hidden w-full  h-[400px]">
          <img
            src={AcedamicsImg}
            alt="carousel-slide"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-5xl font-bold  font-titillium">
              Academic Programmes
            </h2>
            <p className="text-lg mt-10 bg-img-description  font-titillium"></p>
          </div>
        </div>
      </div>

      <div className="flex item-end justify-end mr-5 mt-6">
        <div className="flex items-center justify-center gap-2 text-primary-color">
          <span>
            <a
              href="#"
              className="text-primary-color underline hover:text-secondary-color"
            >
              International Section
            </a>
          </span>
          <FaLink />
          <TiArrowSortedDown
            onClick={scrollToBottom}
            className="cursor-pointer text-xl hover:text-secondary-color"
          />
        </div>
      </div>

      <div className="py-6 mt-6">
        <div id="undergraduate">
          {" "}
          <h2 className="text-4xl text-primary-color  font-titillium">
            Undergraduate Programmes
          </h2>
        </div>

        <div className="px-4 sm:px-8 md:px-28 py-6 mt-6">
          {/* Departments Section */}
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-6 gap-x-6 justify-items-center">
            {departmentsData.map((department, index) => {
              let bgColor = "";
              let className = "bg-primary-color"; // Default class
              if (
                department.department_name ===
                "Department of Accounting and Management"
              ) {
                bgColor = MAROON;
                className = ""; // Remove default class
              } else if (
                department.department_name ===
                "Department of Business Analytics"
              ) {
                bgColor = PURPLE;
                className = ""; // Remove default class
              }

              return (
                <button
                  key={department.id}
                  className={`rounded-lg text-white
      w-[90%] sm:w-[70%] md:w-[80%] lg:w-[20rem] lg:h-[20rem] 
      xl:w-[22rem] xl:h-[22rem] 2xl:w-[24rem] 2xl:h-[24rem]
      flex flex-col justify-between p-6 ${className}`} // Add bgColor here
                  style={{ backgroundColor: bgColor || undefined }}
                  onClick={() => navigate(`/department?id=${department.id}`)}
                >
                  <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-inter text-left">
                    {department.department_name}
                  </h2>
                  <div className="flex justify-end"></div>
                </button>
              );
            })}
          </div>
        </div>

        <div className="py-6 mt-6" id="postGraduate">
          {" "}
          <h2 className="text-4xl text-primary-color  font-titillium">
            Post Graduate Programmes
          </h2>
        </div>
        <div className="px-4 sm:px-8 md:px-28 py-6 mt-6">
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-6 gap-x-6 justify-items-center">
            <a
              href="https://www.casrilanka.com/casl/index.php?option=com_content&view=article&id=3960&Itemid=568&lang=en"
              target="_blank"
              rel="noopener noreferrer"
              className={`rounded-lg text-white
                  w-[90%] sm:w-[70%] md:w-[80%] lg:w-[20rem] lg:h-[15rem] 
                  xl:w-[22rem] xl:h-[18rem] 2xl:w-[24rem] 2xl:h-[20rem]
                  flex flex-col justify-between p-6 bg-GOLDEN_YELLOW`}
            >
              <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-inter text-left">
                MBA
              </h2>
              <p className="text-white text-sm line-clamp-3 font-inter text-left"></p>
              <div className="flex justify-end"></div>
            </a>
          </div>
        </div>

        {/* <div className="relative max-w-full mx-auto">
          <div className="contain overflow-hidden w-full h-[280px]">
            <img
              src={Background}
              alt="carousel-slide"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div> */}
        <div className="px-4 sm:px-8 md:px-28">
          <div className="py-6 mt-6">
            <div id="programs">
              {" "}
              <h2 className="text-2xl sm:text-3xl md:text-4xl text-primary-color text-center md:text-left  font-titillium">
                Affiliate Programmes
              </h2>
            </div>

            <div className="py-4">
              <h2 className="text-left text-primary-color text-2xl sm:text-3xl md:text-4xl  font-titillium">
                ProUniSQ Programmes
              </h2>
              <div className="bg-primary-color h-[1px] w-[150px] sm:w-[200px] md:w-[300px] mt-3"></div>
            </div>
            {/* Program Cards Section - Similar to Department Cards */}

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-6 gap-x-6 justify-items-center">
              {programsData.map((program) => (
                <Link
                  to={`/programs?id=${program.id}`}
                  key={program.id}
                  className={`rounded-lg  text-white
                                        w-[90%] sm:w-[70%] md:w-[80%] lg:w-[20rem] lg:h-[15rem] 
                                        xl:w-[22rem] xl:h-[18rem] 2xl:w-[24rem] 2xl:h-[20rem]
                                        flex flex-col justify-between p-6 bg-DARK_BLUE`}
                >
                  <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-inter text-left">
                    {parse(program.program_name)}
                  </h2>
                  <p className="text-white text-sm line-clamp-3 font-inter text-left"></p>
                  <div className="flex justify-end"></div>
                </Link>
              ))}
            </div>

            {/* 
                <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-6 gap-x-6 justify-items-center">
                            {programsData.map((program, index) => (
                                <Link
                                    to={`/programs/${program.id}`}
                                    key={program.id}
                                    className={`rounded-lg ${index % 2 === 0 ? "bg-Footer-color" : "bg-[#3F3F3F]"
                                        } 
                                        w-[90%] sm:w-[70%] md:w-[80%] lg:w-[20rem] lg:h-[15rem] 
                                        xl:w-[22rem] xl:h-[18rem] 2xl:w-[24rem] 2xl:h-[20rem]
                                        flex flex-col justify-between p-6`}
                                >
                                    <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-inter text-left">
                                        {parse(program.program_name)}
                                    </h2>
                                    <p className="text-white text-sm line-clamp-3 font-inter text-left">
                                        {parse(program.alumniNews_description)}
                                    </p>
                                    <div className="flex justify-end">
                                        <GoArrowRight className="text-xl text-primary-color " />
                                    </div>
                                </Link>
                            ))}
                        </div> */}
            <div className=" py-6">
              <div className="py-6 mt-6" id="loan">
                <h2 className="text-left text-primary-color text-2xl sm:text-3xl md:text-4xl  font-titillium">
                  Interest Free Student Loan Scheme
                </h2>
                <div className="bg-primary-color h-[1px] w-[150px] sm:w-[200px] md:w-[300px] mt-3"></div>
              </div>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-6 gap-x-6 justify-items-center">
                {loanData.map((loan) => (
                  <button
                    key={loan.id}
                    className={`rounded-lg text-white
                                    w-[90%] sm:w-[70%] md:w-[80%] lg:w-[20rem] lg:h-[20rem] 
                                    xl:w-[22rem] xl:h-[22rem] 2xl:w-[24rem] 2xl:h-[24rem]
                                    flex flex-col justify-between p-6 bg-GREY`}
                    onClick={() => navigate(`/loans?id=${loan.id}`)}
                  >
                    <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-inter text-left">
                      {loan.title}
                    </h2>
                    <div className="flex justify-end"></div>
                  </button>
                ))}
              </div>
              {/* 
                            Tab Navigation
                            <div className="flex border-b border-gray-300">
                                {loanData.map((loan, index) => (
                                    <button
                                        key={loan.id}
                                        className={`w-[50%] py-4 text-center text-xl font-semibold ${activeTab === index
                                            ? "text-primary-color border-b-4 bg-gray-200"
                                            : "text-gray-600"
                                            }`}
                                        onClick={() => setActiveTab(index)}
                                    >
                                        {loan.title}
                                    </button>
                                ))}
                            </div> */}

              {/* 
              <div className="p-4 sm:p-6 md:p-8 bg-white h-auto overflow-y-auto mt-6">
                {loanData[activeTab] && (
                  <div className="grid grid-cols-1 gap-6">
                    <div className="px-8">
             
                      <div className="py-6 mt-6">
                        <p className="text-justify">
                          {parse(loanData[activeTab].description)}
                        </p>
                      </div>

                      <div className="py-5">
                        <div className="border rounded border-primary-color w-full sm:w-[200px] h-10 flex items-center justify-center mx-auto md:mx-0">
                          <h1 className="text-primary-color font-bold text-left">
                            Eligibility Criteria
                          </h1>
                        </div>
                        <ul className="py-6 grid gap-y-3 text-justify">
                          {parse(loanData[activeTab].eligibity_criteria, {
                            replace: (domNode) => {
                              if (domNode.name === "li") {
                                return (
                                  <li className="text-justify">
                                    {domToReact(domNode.children)}
                                  </li>
                                );
                              }
                              if (domNode.name === "ul") {
                                return (
                                  <ul className="list-disc pl-6">
                                    {domToReact(domNode.children)}
                                  </ul>
                                );
                              }
                            },
                          })}
                        </ul>
                      </div>

              
                      <div className="py-5">
                        <div className="border rounded border-primary-color w-full sm:w-[200px] h-10 flex items-center justify-center mx-auto md:mx-0">
                          <h1 className="text-primary-color font-bold text-left">
                            Application Process
                          </h1>
                        </div>
                        <ul className="py-6 grid gap-y-3 text-justify">
                          {parse(loanData[activeTab].application_process, {
                            replace: (domNode) => {
                              if (domNode.name === "li") {
                                return (
                                  <li className="text-justify">
                                    {domToReact(domNode.children)}
                                  </li>
                                );
                              }
                              if (domNode.name === "ul") {
                                return (
                                  <ul className="list-decimal pl-6">
                                    {domToReact(domNode.children)}
                                  </ul>
                                );
                              }
                            },
                          })}
                        </ul>
                      </div>

            
                      <div className="py-5">
                        <div className="border rounded border-primary-color w-full sm:w-[200px] h-10 flex items-center justify-center mx-auto md:mx-0">
                          <h1 className="text-primary-color font-bold text-left">
                            Contact Information
                          </h1>
                        </div>
                        <ul className="py-6 grid gap-y-3 text-justify">
                          {parse(loanData[activeTab].contact_information, {
                            replace: (domNode) => {
                              if (domNode.name === "li") {
                                return (
                                  <li className="text-justify">
                                    {domToReact(domNode.children)}
                                  </li>
                                );
                              }
                              if (domNode.name === "ul") {
                                return (
                                  <ul className="list-disc pl-6">
                                    {domToReact(domNode.children)}
                                  </ul>
                                );
                              }
                            },
                          })}
                        </ul>
                      </div>

                      <div className="py-5">
                        <h1 className="text-primary-color font-bold text-left">
                          Supporting Documents:
                        </h1>
                        <div className="py-6 px-4 sm:px-6">
                          <ul className="list-disc text-justify">
                            {loanData[activeTab].files.map((file, i) => (
                              <li key={i} className="underline">
                                <a
                                  href={file}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Document {i + 1}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div> */}
            </div>
          </div>
          <div id="careers" className="py-6">
            <p className="text-4xl text-primary-color  font-titillium ">
              Career Guidence & InternShips
            </p>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-6 gap-x-6 justify-items-center">
              {internshipData.map((internship) => (
                <button
                  key={internship.id}
                  className={`rounded-lg text-white
                                    w-[90%] sm:w-[70%] md:w-[80%] lg:w-[20rem] lg:h-[20rem] 
                                    xl:w-[22rem] xl:h-[22rem] 2xl:w-[24rem] 2xl:h-[24rem]
                                    flex flex-col justify-between p-6 bg-[#92288C] bg-opacity-40`}
                  onClick={() => navigate(`/training-patners`)}
                >
                  <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-inter text-left">
                    {internship.title}
                  </h2>
                  <div className="flex justify-end"></div>
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="relative w-full mt-6">
          {/* <div className="w-full h-[150px]">
            <img
              src={
                "https://studyinternational.com/wp-content/uploads/2019/01/The-high-cost-of-graduation-ceremonies.jpg"
              }
              alt="carousel-slide"
              className="w-full h-full object-cover object-center"
            />
            <div
              className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white font-titillium"
              id="cqa"
            >
              <h2 className="text-2xl sm:text-3xl font-bold">
                Center for Quality Assurance (CQA)
              </h2>
            </div>
          </div> */}

          <h2 className=" text-primary-color text-2xl sm:text-3xl md:text-4xl  font-titillium">
            CQA
          </h2>
        </div>

        {/* Quality Assurance Description */}
        <div className="py-6 px-4 md:px-20">
          {CQADescriptionData && CQADescriptionData.length > 0 ? (
            CQADescriptionData.map((cqa, index) => (
              <p
                key={cqa.id}
                className={`text-justify font-inter ${
                  showFullText ? "" : "line-clamp-3"
                } leading-relaxed`}
              >
                {safeParse(cqa.cqa_description)}
              </p>
            ))
          ) : (
            <p>No CQA description available.</p>
          )}
          <button
            className="text-primary-color font-semibold mt-2"
            onClick={() => setShowFullText(!showFullText)}
          >
            {showFullText ? "Read Less" : "Read More"}
          </button>

          <div className="py-10 mt-10 px-4 md:px-10 lg:px-28 relative">
            <div className="border border-gray-200 w-full h-auto rounded-lg ">
              {/* Title */}
              {/* <h2 className="font-bold text-3xl py-6 text-center font-titillium text-gray-800">
                Resource List
              </h2> */}
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-6 gap-x-6 justify-items-center">
                {CQAData.map((cqa) => (
                  <button
                    key={cqa.id}
                    className={`rounded-lg text-white
                                    w-[90%] sm:w-[70%] md:w-[80%] lg:w-[20rem] lg:h-[20rem] 
                                    xl:w-[22rem] xl:h-[22rem] 2xl:w-[24rem] 2xl:h-[24rem]
                                    flex flex-col justify-between p-6 bg-Footer-color`}
                    onClick={() => navigate(`/cqa?id=${cqa.id}`)}
                  >
                    <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-inter text-left">
                      {cqa.title}
                    </h2>
                    <div className="flex justify-end"></div>
                  </button>
                ))}
              </div>
              {/* Slider Container */}
              {/* <div className="p-6 md:p-10 bg-white relative">

                <button
                  className="absolute left-[-2rem] top-1/2 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md hover:bg-gray-200 transition-all hidden lg:flex"
                  onClick={() => sliderRef.current.slickPrev()}
                >
                  <FaChevronLeft className="text-xl text-primary-color" />
                </button>

                <Slider ref={sliderRef} {...settings}>
                  {CQAData.map((item) =>
                    item.files.map((file, index) => (
                      <div key={`${item.id}-${index}`} className="px-4">
                        <div className="border-dotted border-2 border-primary-color rounded-xl p-6 text-left shadow-md">
        
                          <h2 className="text-gray-800 text-lg">
                            <span className="font-semibold text-primary-color">
                              Title:{" "}
                            </span>
                            {parse(item.title)}
                          </h2>

 
                          <p className="mt-2 text-gray-700 text-lg">
                            <span className="font-semibold text-primary-color">
                              Description:{" "}
                            </span>
                            {parse(item.description)}
                          </p>

                          <div className="mt-4">
                            <a
                              href={file}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-primary-color font-semibold inline-flex items-center hover:text-purple-700 transition-all"
                            >
                              Download File {index + 1}
                              <span className="ml-2">
                                <BsFillFileEarmarkPdfFill className="text-xl" />
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </Slider>

                <button
                  className="absolute right-[-2rem] top-1/2 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md hover:bg-gray-200 transition-all hidden lg:flex"
                  onClick={() => sliderRef.current.slickNext()}
                >
                  <FaChevronRight className="text-xl text-primary-color" />
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Acadamics;
